import api from "@/api";
import { create, update } from "lodash";
import * as types from "./mutation-types";
import { initialState } from "./state";

export const actions = {
  // set the initial state
  getBaseNotification({ commit }) {
    commit(types.SET_NOTIFICATION_STATE, { ...initialState });
  },
  setFilterCategories({ commit }, state) {
    commit(types.SET_FILTER_CATEGORY, state);
  },
  /**
   * Method to list all notifications available
   * Allows for search and pagination
   */
  async list({ commit, state }, options) {
    const localOptions = { ...options };
    const page = localOptions.page ? localOptions.page : 1;
    const size = state.pagination.per_page;
    let from = size * page - size;

    if (!from) {
      from = 0;
    }
    const filter = {
      size,
      from,
      sort: [
        {
          [state.sortBy.field]: {
            order: state.sortBy.direction,
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              bool: {
                should: [
                  {
                    match: {
                      tag_names: {
                        query: state.filters.searchQuery,
                        operator: "and",
                        zero_terms_query: "all",
                        fuzziness: "AUTO",
                      },
                    },
                  },
                  {
                    bool: {
                      should: [
                        {
                          match: {
                            title: {
                              query: state.filters.searchQuery,
                              operator: "and",
                              zero_terms_query: "all",
                              fuzziness: "AUTO",
                            },
                          },
                        },
                        {
                          match_phrase_prefix: {
                            title: {
                              query: state.filters.searchQuery,
                              slop: 50,
                            },
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    };

    if (state.filters.categories.length >= 1) {
      filter.query.bool.must.push({
        terms: {
          status: state.filters.categories,
        },
      });
    }

    let resp;
    try {
      resp = await api().put("/fcm/messages/flat", { filter });
      commit(types.SET_NOTIFICATIONS, resp.data.data.message);
      commit(types.SET_FILTER_TOTAL, resp.data.meta.filter_total);
      commit(types.SET_CURRENT_PAGE, page);
      return Promise.resolve(resp.data.data.message);
    } catch (err) {
      console.log("🚀 ~ file: actions.js ~ line 30 ~ list ~ err", err);
      commit(types.SET_NOTIFICATIONS, []);
      commit(types.SET_FILTER_TOTAL, 0);
      commit(types.SET_CURRENT_PAGE, 1);
      return Promise.resolve([]);
    }
  },

  async read({ commit }, id) {
    let resp;

    try {
      resp = await api().get(`/fcm/message/${id}`);
      // we only need certain fields
      const message = resp.data.data.message[0];
      const fields = Object.keys(initialState);
      let filterMessage = {};
      fields.forEach((field) => {
        filterMessage[field] = message[field];
      });
      // if there are any users, make sure they are only ids
      if (message.users && message.users.length > 0) {
        filterMessage.users = message.users.map((usr) => ({
          id: usr.id,
          name: usr.name,
        }));
      }
      commit(types.SET_NOTIFICATION_STATE, filterMessage);
      return Promise.resolve(filterMessage);
    } catch (err) {
      console.log("🚀 ~ file: actions.js ~ line 103 ~ read ~ err", err);
      return Promise.reject(new Error(err));
    }
  },

  async create({ state, commit }, id = null) {
    let resp;
    const { currentNotification } = state;

    try {
      let url = "/fcm/message";
      if (id) {
        url += `/${id}`;
      }
      resp = await api().post(url, { message: currentNotification });
      // commit(types.RESET_CURRENT_NOTIFICATION);
      console.log(
        "🚀 ~ file: actions.js ~ line 103 ~ create ~ resp.data.data.message[0]",
        resp.data.data.message[0]
      );
      return Promise.resolve(resp.data.data.message[0]);
    } catch (err) {
      console.log("🚀 ~ file: actions.js ~ line 105 ~ create ~ err", err);
      return Promise.reject(err);
    }
  },

  async update({ dispatch, state }) {
    dispatch("create", state.currentNotification.id);
  },

  async delete(context, id) {
    let resp;

    try {
      resp = await api().delete(`/fcm/message/${id}`);
      return Promise.resolve();
    } catch (err) {
      return Promise.reject();
    }
  },
  async send(context, id) {
    let resp;

    try {
      resp = await api().post(`/fcm/message/${id}/send`);
      return Promise.resolve();
    } catch (err) {
      return Promise.reject();
    }
  },
};
